import { z } from "zod";
/** The one consent type captured today: HealthOS beta participation. */
export const BETA_CONSENT_TYPE = "beta_participation";
export const RecordBetaConsentRequest = z.object({
    consentType: z.string().min(1).default(BETA_CONSENT_TYPE),
    version: z.string().min(1),
    consentText: z.string().min(1),
});
export const BetaConsentRecord = z.object({
    id: z.string(),
    consentType: z.string(),
    version: z.string(),
    granted: z.boolean(),
    grantedAt: z.string(),
});
export const RecordBetaConsentResponse = z.object({
    consent: BetaConsentRecord,
});
export const GetBetaConsentResponse = z.object({
    consent: BetaConsentRecord.nullable(),
});
//# sourceMappingURL=consent.js.map